import { WIDGET_CONNECTOR_EMBED_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { getExperienceTracker } from '@confluence/experience-tracker/entry-points/getExperienceTracker.ts';

export interface WidgetConnectorExtension {
	hostLabel?: string | null;
	url?: string | null;
}

type MaybeWidgetConnectorExtension = WidgetConnectorExtension | null | undefined;

type WidgetConnectorExperienceTrackerSupportApi = {
	isTrackable(extension: MaybeWidgetConnectorExtension): boolean;
	start(extension: MaybeWidgetConnectorExtension): void;
	succeed(): void;
	fail(messageOrError: string | Error): void;
	abort(reason: string): void;
};

const getError = (messageOrError: string | Error): Error => {
	if (messageOrError instanceof Error) {
		return messageOrError;
	}

	return new Error(messageOrError);
};

/**
 * Experience tracker support for the "Widget connector embed" capability (Group 6
 * of the @ecosystem Feature Test Migration). Emits the
 * WIDGET_CONNECTOR_EMBED_EXPERIENCE experience so a TOME SLO can be defined for
 * third-party widget embeds (YouTube, etc.) rendered by the widget macro.
 *
 * Mirrors the canonical ConnectCustomContentExperienceTrackerSupport pattern.
 */
export const WidgetConnectorExperienceTrackerSupport: WidgetConnectorExperienceTrackerSupportApi =
	new (class WidgetConnectorExperienceTrackerSupport {
		isTrackable(extension: MaybeWidgetConnectorExtension): boolean {
			return Boolean(extension?.url);
		}

		start(extension: MaybeWidgetConnectorExtension): void {
			getExperienceTracker().start({
				name: WIDGET_CONNECTOR_EMBED_EXPERIENCE,
				attributes: {
					hostLabel: extension?.hostLabel,
				},
			});
		}

		succeed(): void {
			getExperienceTracker().succeed({
				name: WIDGET_CONNECTOR_EMBED_EXPERIENCE,
			});
		}

		fail(messageOrError: string | Error): void {
			getExperienceTracker().fail({
				name: WIDGET_CONNECTOR_EMBED_EXPERIENCE,
				error: getError(messageOrError),
			});
		}

		abort(reason: string): void {
			getExperienceTracker().abort({
				name: WIDGET_CONNECTOR_EMBED_EXPERIENCE,
				reason,
			});
		}
	})();
